module.exports = __webpack_public_path__ + "img/tick-in-circle.d62695ec.svg";